import Accordion from '../components/Accordion/Accordion';
import './BitacoraSection.css';

const BitacoraSection = ({ title, subtitle, accordionItems, accordionIcon }) => {
  return (
    <section className="bitacora-section py-12 md:py-16 bg-[var(--bg-secondary)] environmental-theme">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[var(--text-primary)] mb-2">{title}</h2>
          {subtitle && <p className="text-lg text-[var(--text-secondary)]">{subtitle}</p>}
        </div>
        <Accordion items={accordionItems} icon={accordionIcon} />
      </div>
    </section>
  );
};

export default BitacoraSection;